<app-dropdown #menu="appDropdown" [triggerLabel]="triggerLabel()">
  <ng-container *appDropdownContent>
    <app-language-menu-item />
    <app-unit-system-menu-item />
    <div
      class="dropdown-item logout-item"
      (click)="logout(); menu.close()"
      tabindex="0"
      (keydown.enter)="logout(); menu.close()"
    >
      <div class="item-content">
        <mat-icon>logout</mat-icon>
        <span>{{ "shared.profile_dropdown.logout" | translate }}</span>
      </div>
    </div>

    <div
      class="dropdown-item logout-item"
      (click)="openCookieSettings()"
      tabindex="0"
      (keydown.enter)="openCookieSettings()"
    >
      <div class="item-content">
        <mat-icon>cookies</mat-icon>
        <span>{{ "shared.gdpr.settings.title" | translate }}</span>
      </div>
    </div>
  </ng-container>
</app-dropdown>
